// Recovered compiled webpack factory 22039. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { OQ: () => h, bt: () => a });
  var n = i(8453),
    s = i(45242),
    r = i(27424),
    o = i(73934);
  let a = { current: void 0 };
  class l {
    constructor(t, e = {}) {
      ((this.canTrackVelocity = null),
        (this.events = {}),
        (this.updateAndNotify = (t) => {
          let e = r.k.now();
          if (
            (this.updatedAt !== e && this.setPrevFrameValue(),
            (this.prev = this.current),
            this.setCurrent(t),
            this.current !== this.prev &&
              (this.events.change?.notify(this.current), this.dependents))
          )
            for (let t of this.dependents) t.dirty();
        }),
        (this.hasAnimated = !1),
        this.setCurrent(t),
        (this.owner = e.owner));
    }
    setCurrent(t) {
      ((this.current = t),
        (this.updatedAt = r.k.now()),
        null === this.canTrackVelocity &&
          void 0 !== t &&
          (this.canTrackVelocity = !isNaN(parseFloat(this.current))));
    }
    setPrevFrameValue(t = this.current) {
      ((this.prevFrameValue = t), (this.prevUpdatedAt = this.updatedAt));
    }
    onChange(t) {
      return this.on("change", t);
    }
    on(t, e) {
      this.events[t] || (this.events[t] = new n.v());
      let i = this.events[t].add(e);
      return "change" === t
        ? () => {
            (i(),
              o.Gt.read(() => {
                this.events.change.getSize() || this.stop();
              }));
          }
        : i;
    }
    clearListeners() {
      for (let t in this.events) this.events[t].clear();
    }
    attach(t, e) {
      ((this.passiveEffect = t), (this.stopPassiveEffect = e));
    }
    set(t) {
      this.passiveEffect ? this.passiveEffect(t, this.updateAndNotify) : this.updateAndNotify(t);
    }
    setWithVelocity(t, e, i) {
      (this.set(e),
        (this.prev = void 0),
        (this.prevFrameValue = t),
        (this.prevUpdatedAt = this.updatedAt - i));
    }
    jump(t, e = !0) {
      (this.updateAndNotify(t),
        (this.prev = t),
        (this.prevUpdatedAt = this.prevFrameValue = void 0),
        e && this.stop(),
        this.stopPassiveEffect && this.stopPassiveEffect());
    }
    dirty() {
      this.events.change?.notify(this.current);
    }
    addDependent(t) {
      (this.dependents || (this.dependents = new Set()), this.dependents.add(t));
    }
    removeDependent(t) {
      this.dependents && this.dependents.delete(t);
    }
    get() {
      return (a.current && a.current.push(this), this.current);
    }
    getPrevious() {
      return this.prev;
    }
    getVelocity() {
      let t = r.k.now();
      if (!this.canTrackVelocity || void 0 === this.prevFrameValue || t - this.updatedAt > 30)
        return 0;
      let e = Math.min(this.updatedAt - this.prevUpdatedAt, 30);
      return (0, s.f)(parseFloat(this.current) - parseFloat(this.prevFrameValue), e);
    }
    start(t) {
      return (
        this.stop(),
        new Promise((e) => {
          ((this.hasAnimated = !0),
            (this.animation = t(e)),
            this.events.animationStart && this.events.animationStart.notify());
        }).then(() => {
          (this.events.animationComplete && this.events.animationComplete.notify(),
            this.clearAnimation());
        })
      );
    }
    stop() {
      (this.animation &&
        (this.animation.stop(),
        this.events.animationCancel && this.events.animationCancel.notify()),
        this.clearAnimation());
    }
    isAnimating() {
      return !!this.animation;
    }
    clearAnimation() {
      delete this.animation;
    }
    destroy() {
      (this.dependents?.clear(),
        this.events.destroy?.notify(),
        this.clearListeners(),
        this.stop(),
        this.stopPassiveEffect && this.stopPassiveEffect());
    }
  }
  function h(t, e) {
    return new l(t, e);
  }
}
